// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"7337":"ad2866b8","8445":"bc98253f"}[chunkId] || chunkId) + "." + {"3969":"640b626f4009d884","7337":"bd3bce0543804603","8445":"f6efc8d1e0028bf6","8848":"ebf10357c7aed02d"}[chunkId] + ".js";
};